import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Primarycare from "./pages/landing/Primarycare";
import Notfound from "./pages/landing/Notfound";
import Getapp from "./pages/landing/Getapp";
import Ecosystem from "./pages/landing/Ecosystem";
import Healthcare from "./pages/landing/Healthcare";
import Login from "./pages/registry/Login";
import Signup from "./pages/registry/Signup";
import Verify from "./pages/registry/Verify";
import Dashboard from "./pages/dashboard"
import { useRecoilValue } from "recoil";
import { user } from "./atom";
import DashboardNot from "./pages/dashboard/DashboardNot";
function App() {
  const currentuser = useRecoilValue(user);
  const routes = [
    { element: <Primarycare />, path: "/landing/primarycare" },
    { element: <Notfound />, path: "/landing/*" },
    { element: <Getapp />, path: "/landing/getapp" },
    { element: <Healthcare />, path: "/landing/heathcare" },
    { element: <Ecosystem />, path: "/landing/ecosystem" },
    { element: <Login />, path: "/registry/login" },
    { element: <Signup />, path: "/registry/signup" },
    { element: <Verify />, path: "/verify/*" },
    { element: <Dashboard />, path: "/" },
    { element: currentuser ? <DashboardNot /> : <Notfound />, path: "/*" },
  ];
  return (
    <Router>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} element={route.element} path={route.path} />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
